import { useState } from 'react';
import axios from 'axios';
import config from '../config';

export function usePinLookup() {
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [pincodeSuggestions, setPincodeSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchByCity = async (cityName) => {
    setLoading(true);
    try {
    //   const res = await axios.get(
    //     `http://www.postalpincode.in/api/pincode/${cityName}`
    //   );
      const res = await axios.get(`${config.API_BASE_URL}/city-search?query=${cityName}`);
      const data = res.data[0]?.PostOffice || [];
      setCitySuggestions(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchByPincode = async (pincode) => {
    setLoading(true);
    try {
      const res = await axios.get(`${config.API_BASE_URL}/pincode-search?pincode=${pincode}`);
      const data = res.data[0]?.PostOffice || [];
      setPincodeSuggestions(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return { citySuggestions, pincodeSuggestions, fetchByCity, fetchByPincode, loading };
}
